export const PRO_CAMERA_MISSING_GRACE_MS = 4000;
export const PRO_CAMERA_REPUBLISH_COOLDOWN_MS = 12000;

export const shouldRequestProCameraRepublish = ({
  missingSince,
  lastRequestAt = 0,
  now = Date.now(),
  graceMs = PRO_CAMERA_MISSING_GRACE_MS,
  cooldownMs = PRO_CAMERA_REPUBLISH_COOLDOWN_MS,
}) => Boolean(
  missingSince
  && now - missingSince >= graceMs
  && (!lastRequestAt || now - lastRequestAt >= cooldownMs)
);
